import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import ad3c29b0ae9721bc671c7d58adbe15fd4b from "./generated-3961dcb4-5de6-4b75-b9ba-85619585025f.json";

import a9296c5e92bf69e77685acb10875d4636b from "./generated-a13197db-497d-4012-b1bc-062e6ba32ffc.json";

import ad8a5d10eac78b1fbaf2a8bd1b83ad92ab from "./generated-7eddaf74-9756-4306-864c-4160e646f1dc.json";

import a1ffe46022a0aa4850df9f3f61e0715fab from "./generated-54307fb4-8f79-4748-b83b-a0e4a411cd0b.json";

import a8ab0c39d933c71b50cee4c5d923d3939b from "./generated-6d087d72-4390-4647-931f-fa63ccd2064f.json";

import a53b6aec4c7f3be3b2f3b02bfe5480631b from "./generated-d00f1323-c59b-45b4-b66f-d9db89e77482.json";

import ac5a383a4352be546e9ebb34c7477d305b from "./generated-e0062e62-2683-4d32-84e4-7d0bb5a05c2d.json";

import a6d8578d6458a809212b3814eb990e5ecb from "./generated-a34c120e-fdb6-41ab-9455-15a7e0b4c8c2.json";

import a470e90975cf182c24f547339db54524ab from "./generated-f357a25c-265f-431f-89b4-11c7cb4601e4.json";

import a73a0ed45874bad1c72bb981c7a3d51edb from "./generated-16a811de-6e7c-488c-b7f4-9017bb000fac.json";

import ab32b435fad971aa96b36a39b09961646b from "./generated-696b2c88-b0a0-4c1b-b3b3-03173917a4b6.json";

import aa493808466bb2694afa44d14d094e53db from "./generated-811b1e0e-47c0-4f21-8632-7c1d99d3dee6.json";

import adf03763b66bfb8fa022107741f8c4b3cb from "./generated-b1a808a8-2339-4fd9-83c2-a1479dbdac01.json";

import aa8da99519639c28ff76b01ea396f4ad8b from "./generated-3542721d-05cc-441c-844f-c068cdcf26d4.json";

import a975d42120c25765261a514eacde52c58b from "./generated-30295065-c6fe-4316-8431-38d47dda257e.json";

import ac911aa0d12c065938d3d9fb656922f0fb from "./generated-028e2a8d-f96c-4c23-8058-d6c06a55242c.json";

import aef42b4b85e73393fbb0f15960ce6f583b from "./generated-c65742e0-7cc8-428c-b6da-a84703ec0b17.json";

import ab4db176a1cdb3c6b718af3d8433a0424b from "./generated-c7d49696-1046-4193-9c04-42d94612a1dc.json";

import a7ec06d266797fb2ae398c8b96b5f870cb from "./generated-d7e0da66-228d-4fd4-945b-956377734433.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(ad3c29b0ae9721bc671c7d58adbe15fd4b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a9296c5e92bf69e77685acb10875d4636b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(ad8a5d10eac78b1fbaf2a8bd1b83ad92ab);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a1ffe46022a0aa4850df9f3f61e0715fab);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a8ab0c39d933c71b50cee4c5d923d3939b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a53b6aec4c7f3be3b2f3b02bfe5480631b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(ac5a383a4352be546e9ebb34c7477d305b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a6d8578d6458a809212b3814eb990e5ecb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a470e90975cf182c24f547339db54524ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a73a0ed45874bad1c72bb981c7a3d51edb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(ab32b435fad971aa96b36a39b09961646b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(aa493808466bb2694afa44d14d094e53db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(adf03763b66bfb8fa022107741f8c4b3cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(aa8da99519639c28ff76b01ea396f4ad8b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a975d42120c25765261a514eacde52c58b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(ac911aa0d12c065938d3d9fb656922f0fb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(aef42b4b85e73393fbb0f15960ce6f583b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(ab4db176a1cdb3c6b718af3d8433a0424b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a7ec06d266797fb2ae398c8b96b5f870cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(aef42b4b85e73393fbb0f15960ce6f583b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */